import React, { Component } from 'react';
import { Modal, Checkbox, Button, Spin, Tooltip, Icon, message, Table } from 'antd';
import ExportUtil from '../../../common/ExportUtil';
import TableC from '../../basicElement/TableC';
import $ from '../../../common/AjaxRequest';
import API_URL from '../../../common/url';

class View extends Component {
    state = {
        params: {},
        record: {},
        visible: false,
        loading: false,
    }

    show = (record, params) => {
        this.setState({
            visible: true,
            record,
            params,
            data: [],
            pagination: {
                current: 1,
                pageSize: 5,
            }
        }, () => {
            this.loadData();
        });
    }

    hide = () => {
        this.setState({ visible: false });
    }

    loadData = () => {
        const { params: param, record, pagination } = this.state;
        const { type, crcType, statisticalType } = param;
        const { cur, searchParams } = this.props;
        let url, params = {
            teamLeaderId: searchParams.teamLeaderId,
        };
        if (type == 'invPositionAll') {
            url = API_URL.user.queryOutputRateInvPositionAll;
        } else if (type == 'invPositionCrc') {
            url = API_URL.user.queryOutputRateInvPositionCrc;
        } else if (type == 'dailyPositionAll') {
            url = API_URL.user.queryOutputRateDailyPosition;
        } else if (type == 'total') {
            url = API_URL.user.queryTotalOutputRateDetail;
        }
        const { userId, regionId, outputDate } = record;
        params.date = outputDate;
        if (cur == 'manager') {
            if (statisticalType) {
                if (crcType) {
                    params.statisticalType = statisticalType;
                    params.crcType = crcType;
                    params.leaderId = userId;
                } else {
                    params.statisticalType = statisticalType;
                    params.leaderId = userId;
                }
            } else {
                if (crcType) {
                    params.crcType = crcType;
                    params.leaderId = userId;
                } else {
                    params.leaderId = userId;
                }
            }
        } else {
            if (crcType) {
                params.crcType = crcType;
                params.cityId = regionId;
            } else {
                params.cityId = regionId;
            }
        }

        const { current, pageSize } = pagination;
        this.setState({ loading: true });
        const options = {
            method: 'POST',
            url,
            data: {
                ...params,
                limit: pagination.pageSize,
                offset: pagination.current,
            },
            dataType: 'json',
            doneResult: res => {
                const { datas, totalCount } = res;
                pagination.total = totalCount;
                const data = (datas || []).map((item, index) => {
                    return {
                        ...item,
                        idx: (current - 1 || 0) * pageSize + index + 1
                    }
                });
                this.setState({
                    data,
                    pagination,
                    loading: false,
                });
            },
        };
        $.sendRequest(options);
    }

    export = () => {
        const { params: param, record, pagination } = this.state;
        const { type, crcType, statisticalType } = param;
        const { cur, searchParams } = this.props;
        let url, params = {
            teamLeaderId: searchParams.teamLeaderId,
        };
        if (type == 'invPositionAll') {
            url = API_URL.user.exportOutputRateInvPositionAll;
        } else if (type == 'invPositionCrc') {
            if (crcType) {
                params.crcType = crcType;
            } else {
                params.statisticalType = statisticalType;
            }
            url = API_URL.user.exportOutputRateInvPositionCrc;
        } else if (type == 'dailyPositionAll') {
            url = API_URL.user.exportOutputRateDailyPosition;
        } else if (type == 'total') {
            url = API_URL.user.exportTotalOutputRateDetail;
        }
        const { userId, regionId, outputDate } = record;
        params.date = outputDate;
        if (cur == 'manager') {
            params.leaderId = userId;
        } else {
            params.cityId = regionId;
        }
        ExportUtil.export(params, pagination, url);
    }

    getColumns = () => {
        const { params } = this.state;
        const { cur } = this.props;
        const { type } = params;
        const columns = [{
            title: '序号',
            dataIndex: 'idx',
            key: 'idx',
            width: 60,
        }, {
            title: '工号',
            dataIndex: 'employeeCode',
            key: 'employeeCode',
            width: 85,
        }, {
            title: '姓名',
            dataIndex: 'userCompellation',
            key: 'userCompellation',
            width: 85,
        }, {
            title: '职位级别',
            dataIndex: 'positionName',
            key: 'positionName',
            width: 120,
        }, {
            title: '状态',
            dataIndex: 'workStatusShow',
            key: 'workStatusShow',
            width: 60,
        }, {
            title: '入职日期',
            dataIndex: 'joinTime',
            key: 'joinTime',
            width: 120,
            render: text => text?text.slice(0,10):''
        }, {
            title: '离职日期',
            dataIndex: 'leftTime',
            key: 'leftTime',
            width: 120,
            render: text => text?text.slice(0,10):''
        }, {
            title: '工作周期(h)',
            dataIndex: 'workHour',
            key: 'workHour',
            width: 80,
        }, {
            title: '主管领导',
            dataIndex: 'leaderName',
            key: 'leaderName',
            width: 85,
        }, {
            title: '工作城市',
            dataIndex: 'workCity',
            key: 'workCity',
            width: 80,
        }];

        if(cur == 'city') {
            columns.push({
                title: '驻外城市',
                dataIndex: '驻外城市',
                key: '驻外城市',
                width: 80,
            });
        }

        if (type == 'invPositionAll' || type == 'invPositionCrc') {
            columns.push({
                title: '项目确认FTE',
                dataIndex: 'consumeFte',
                key: 'consumeFte',
                width: 95,
            }, {
                title: '人员产出率',
                dataIndex: 'outPutRateStr',
                key: 'outPutRateStr',
                width: 80,
            }, {
                title: '访视数',
                dataIndex: 'visitCount',
                key: 'visitCount',
                width: 80,
            }, {
                title: 'CRC项目确认FTE',
                dataIndex: 'crcConsumeFte',
                key: 'crcConsumeFte',
                width: 110,
            }, {
                title: '标准访视数',
                dataIndex: 'standardVisitCount',
                key: 'standardVisitCount',
                width: 80,
            }, {
                title: '访视效率',
                dataIndex: 'visitRate',
                key: 'visitRate',
                width: 80,
            }, {
                title: '方案违背数',
                dataIndex: 'violationCount',
                key: 'violationCount',
                width: 90,
            });
        } else if (type == 'dailyPositionAll') {
            columns.push({
                title: '非项目确认FTE',
                dataIndex: 'consumeFte',
                key: 'consumeFte',
                width: 120,
            },{
                title: '人员产出率',
                dataIndex: 'outPutRateStr',
                key: 'outPutRateStr',
                width: 80,
            });
        } else if (type == 'total') {
            columns.push({
                title: '总FTE',
                dataIndex: 'consumeFte',
                key: 'consumeFte',
                width: 130,
            }, {
                title: '人员产出率',
                dataIndex: 'outPutRateStr',
                key: 'outPutRateStr',
                width: 80,
            }, {
                title: (
                    <span>
                        空余率
                        <Tooltip overlayStyle={{ width: 200 }} placement="topRight" title={'某月个人空余率 = (1-该月个人总FTE)/1*100% (若值小于0，取0)'}>
                            <a><Icon style={{ marginLeft: 6, fontSize: '14px' }} type="info-circle-o" /></a>
                        </Tooltip>
                    </span>
                ),
                dataIndex: 'spareRateStr',
                key: 'spareRateStr',
                width: 135,
            });
        }
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            pagination:{...params}
        }, () => {
            this.loadData();
        });
    }

    render() {
        const { data, visible, loading, record, pagination } = this.state;
        const { outputDate, regionName, userCompellation } = record;
        const { cur } = this.props;
        return (
            <div>
                <Modal
                    title="明细记录"
                    visible={visible}
                    onCancel={this.hide}
                    className="preview-modal"
                    wrapClassName="vertical-center-modal"
                    width={1000}
                    bodyStyle={{ maxHeight: 600 }}
                    footer={<Button key="back" type="ghost" size="large" onClick={this.hide}>关闭</Button>}
                >
                    <div className="cont" style={{ padding: '20px 30px' }}>
                        <div style={{ marginBottom: 20 }}>
                            时间：{outputDate}
                            <span className="ant-divider" />
                            {cur == 'manager' ? <span>团队领导：{userCompellation}</span> : <span>城市：{regionName}</span>}
                            <Button type="primary" style={{ marginLeft: 20 }} onClick={this.export}>导出</Button>
                        </div>
                        <Spin spinning={loading}>
                            <Table
                                dataSource={data}
                                columns={this.getColumns()}
                                pagination={pagination}
                                scroll={{
                                    x:800,
                                    y:400
                                }}
                                onChange={this.handleTableChange}
                            />
                        </Spin>
                    </div>
                </Modal>
            </div>
        );
    }
}

class ExportModal extends Component {
    state = {
        visible: false,
        first: '',
        second: '',
    }

    show = () => {
        this.setState({
            first: '',
            second: '',
            visible: true,
        });
    }

    handleCancel = () => {
        this.setState({ visible: false });
    }

    handleOk = () => {
        const { first, second } = this.state;
        if (!first && !second) {
            message.warning('请选择需要导出的内容');
            return;
        }
        first && this.export(true, first);
        second && this.export(false, second);
        this.handleCancel();
    }

    export = (isFirst, value) => {
        const { cur, searchParams } = this.props;
        const url = cur == 'manager' ? API_URL.user.exportOutputRate : API_URL.user.exportOutputRateByCity;
        let type;
        if (cur == 'manager') {
            type = isFirst ? 'Out_Put_Rate_Director_Sub' : 'Out_Put_Rate_Director_Team';
        } else {
            type = isFirst ? 'Out_Put_Rate_City_Sub' : 'Out_Put_Rate_City_Month';
        }
        this.addToDownloadSite({ ...searchParams, type: value }, url, type);
    }

    addToDownloadSite = (searchArray, url, type) => {
        const options = {
            method: 'POST',
            url: API_URL.common.startAsynchronousExport,
            data: { type },
            dataType: 'json',
            doneResult: (res) => {
                const { success, asynchronousExportId } = res;
                message.success(success);
                const params = { ...searchArray, asynchronousExportId }
                ExportUtil.export(params, null, url);
            },
        };
        $.sendRequest(options);
    }

    handleChange = (e, key) => {
        const target = e.target;
        const checked = target.checked;
        const value = target.value;
        this.setState({ [key]: checked ? value : '' });
    }

    render() {
        const {
            visible,
            first,
            second,
        } = this.state;
        const { cur } = this.props;
        return (
            <Modal
                title="导出"
                visible={visible}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                className="preview-modal"
                wrapClassName="vertical-center-modal"
                width="500px"
            >
                <div className="cont-cont" style={{ padding: '30px 20px' }}>
                    <ul className="preview-list">
                        <li className="preview-item">
                            <div className="item" style={{ width: '35%' }}>
                                <label className="ui-label">请选择需要导出的内容</label>
                            </div>
                        </li>
                        <li className="preview-item">
                            <div className="item checkBoxchildren" >
                                <div><Checkbox onChange={e => this.handleChange(e, 'first')} checked={first} value="SUBORDINATES">
                                    { cur === "manager" ? '人员直线下属的产出率情况' : '相同月份按城市比较的人员产出率情况' }
                                </Checkbox></div>
                                <div><Checkbox onChange={e => this.handleChange(e, 'second')} checked={second} value="OVERALL_TEAM">
                                    { cur === "manager" ? '人员整体团队的产出率情况' : '相同城市按月份比较的人员产出率情况' }
                                </Checkbox></div>
                            </div>
                        </li>
                    </ul>
                </div>
            </Modal>
        )
    }
}

export { View, ExportModal };


// WEBPACK FOOTER //
// ./src/components/user/output/Widget.js